<template>

</template>

<script setup lang="ts">
import {injectAxios} from "@/util/inject";

const axios = injectAxios();

const downloadFile = async (url: string, params: object, fileName: string) => {
  const resp = await axios.get(url, {params: params, responseType: "blob", paramsSerializer: {indexes: null}});
  const blob = new Blob([resp.data]);
  const link = document.createElement("a");

  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();

  URL.revokeObjectURL(link.href);
};

defineExpose({
  downloadFile,
});
</script>
